import { ofType } from 'redux-observable';
import { debounceTime, switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import {
  DEBOUNCED_UPDATE_PRODUCT,
  FETCH_PRODUCT_SUCCESS,
  EPIC_ERROR,
} from 'Constants/redux';
import service from 'Api/service';
import { ROOT_URL } from 'Api';
import {
  apiConnections,
  apiToSingularConnections,
} from 'Constants/displayConstants';

const debouncedUpdateProductEpic = (action$) =>
  action$.pipe(
    ofType(DEBOUNCED_UPDATE_PRODUCT),
    debounceTime(500),
    switchMap((action) =>
      from(
        service.patch(
          `${ROOT_URL}/${apiConnections[action.productType]}/${action.id}`,
          {
            [apiToSingularConnections[action.productType]]: action.data,
          }
        )
      ).pipe(
        map((response) => ({
          type: FETCH_PRODUCT_SUCCESS,
          productType: apiToSingularConnections[action.productType],
          id: action.id,
          response: response.data,
        })),
        catchError((error) => {
          console.error('debouncedUpdateProductEpic', error);
          return of({
            type: EPIC_ERROR,
            error,
          });
        })
      )
    )
  );

export default debouncedUpdateProductEpic;
